import { CoverDetails } from 'slices/coverDetails';

import { Nullable } from '../../../types/utils';

const getCoverDetails = (state: Nullable<CoverDetails>) => {
  if (!state) return {};
  const { liabilityLimit, buildingSI, contentsSI } = state;
  let coverDetailsDataPoints;

  coverDetailsDataPoints = {
    genericDimensionOne: `limit of liability|${liabilityLimit}`,
  };
  // BuildingSI
  if (buildingSI !== undefined)
    coverDetailsDataPoints = {
      ...coverDetailsDataPoints,
      sumInsuredType: 'agreed',
      buildingSI,
    };
  // ContentSI
  if (contentsSI !== undefined)
    coverDetailsDataPoints = {
      ...coverDetailsDataPoints,
      sumInsuredType: 'agreed',
      contentsSI,
    };

  return coverDetailsDataPoints;
};

export default getCoverDetails;
